import React from 'react'
import classNames from 'classnames'
import styles from './somethingWentWrong.module.scss'

interface PropType {
  show?: boolean
  minHeight?: string
  wrapperClass?: string
}

function SomethingWentWrong({ show = true, minHeight, wrapperClass }: PropType) {
  if (!show) return null

  return (
    <div className={classNames(styles.graceful_error_message_wrapper, wrapperClass)} style={{ minHeight }}>
      <div className={styles.graceful_error_message_content}>
        Looks like something is wrong on our end.
        <br />
        Please refresh the page.
      </div>
    </div>
  )
}

export default SomethingWentWrong
